import { createRoot } from 'react-dom/client';
import CustomPCHero from './App.jsx';
function mount() {
  const container = document.getElementById('custom-pc-hero-root');
  if (!container) return;
  const cases = container.dataset.cases ? JSON.parse(container.dataset.cases) : undefined;
  createRoot(container).render(<CustomPCHero cases={cases} />);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
else mount();
